'use client';

import { useState } from 'react';
import MobileMenu from './MobileMenu';

export default function MobileHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="w-full fixed top-0 p-3 flex justify-center items-center z-50 bg-[#f4f4f4]/90 backdrop-blur-md">
        <div className="w-full max-w-4xl flex justify-between items-center px-2.5 py-2">
          {/* Logo */}
          <a 
            href="/" 
            className="flex gap-1 items-center"
            onClick={closeMenu}
          >
            <div className="w-[36px] h-[36px]">
              <img 
                src="/AbbiAI.png" 
                alt="AbbiAI Logo" 
                className="h-full w-full object-contain"
              />
            </div>
            <div className="flex flex-col justify-center items-center">
              <h2 className="text-[18px] font-bold text-darkbrown dark:text-white">
                AbbiAI
              </h2>
              <span className="italic text-xs">IA con Propósito</span>
            </div>
          </a>

          {/* Desktop Navigation - Hidden on mobile */}
          <nav className="hidden md:flex gap-5 items-center text-darkbrown">
            <a 
              href="/" 
              className="hover:underline"
            >
              Inicio
            </a>
            <a 
              href="/pricing" 
              className="hover:underline"
            >
              Precios
            </a>
            <a 
              href="/contact" 
              className="hover:underline"
            >
              Contáctanos
            </a>
          </nav>

          {/* Right side: Menu button (mobile) and CTA button */}
          <div className="flex gap-3 sm:gap-5 items-center">
            {/* Mobile Menu Button - MUY VISIBLE con diseño moderno */}
            <button
              onClick={toggleMenu}
              className="md:hidden flex flex-col gap-1.5 w-12 h-12 items-center justify-center focus:outline-none min-h-[48px] min-w-[48px] rounded-xl bg-white border-2 border-gray-300 hover:border-gray-400 active:border-gray-500 transition-all shadow-lg hover:shadow-xl p-2.5"
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span
                className={`block transition-all duration-300 rounded-full ${
                  isMenuOpen ? 'rotate-45 translate-y-2.5' : ''
                }`}
                style={{ 
                  height: '3px', 
                  width: '28px', 
                  backgroundColor: '#1f2937',
                  display: 'block'
                }}
              />
              <span
                className={`block transition-all duration-300 rounded-full ${
                  isMenuOpen ? 'opacity-0' : ''
                }`}
                style={{ 
                  height: '3px', 
                  width: '28px', 
                  backgroundColor: '#1f2937',
                  display: 'block'
                }}
              />
              <span
                className={`block transition-all duration-300 rounded-full ${
                  isMenuOpen ? '-rotate-45 -translate-y-2.5' : ''
                }`}
                style={{ 
                  height: '3px', 
                  width: '28px', 
                  backgroundColor: '#1f2937',
                  display: 'block'
                }}
              />
            </button>

            {/* CTA Button - Hidden on mobile, shown in menu */}
            <a
              href="https://app.abbiai.it/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex text-darkbrown font-medium px-3 py-2 sm:px-4 sm:py-2 rounded-lg hover:bg-gray-200 transition-colors text-sm sm:text-base min-h-[44px] items-center justify-center"
            >
              Iniciar App
            </a>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMenuOpen} onClose={closeMenu} />
    </>
  );
}
